// Video library included in theme script enqueue

import "./view.scss";

function getLightboxVideoId(node) {
  if (!node) return undefined;
  const popupId = (node.dataset.popupVideoId || "").trim();
  if (popupId && popupId !== "undefined" && popupId !== "null") {
    return popupId;
  }
  return node.dataset.videoId;
}

function getLightboxVideoProvider(node) {
  if (!node) return "vimeo";
  const popupProvider = (node.dataset.popupVideoProvider || "").trim();
  if (
    popupProvider &&
    popupProvider !== "undefined" &&
    popupProvider !== "null"
  ) {
    return popupProvider.toLowerCase();
  }
  const primary = (node.dataset.videoProvider || "").trim();
  return primary ? primary.toLowerCase() : "vimeo";
}

function buildInlineVideoPlayer(node) {
  if (!node) return null;

  const videoId = getLightboxVideoId(node);
  if (!videoId) return null;

  const provider = getLightboxVideoProvider(node);

  if (provider === "youtube") {
    const iframe = document.createElement("iframe");
    iframe.setAttribute(
      "src",
      `https://www.youtube.com/embed/${encodeURIComponent(
        videoId
      )}?autoplay=1&rel=0&modestbranding=1`
    );
    iframe.setAttribute(
      "allow",
      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
    );
    iframe.setAttribute("allowfullscreen", "");
    iframe.setAttribute("title", "YouTube video player");
    iframe.className = "inline-video-youtube";
    iframe.style.cssText = "width:100%;height:100%;border:0;";
    node.appendChild(iframe);

    return {
      ready: () => Promise.resolve(),
      play: () => {},
      destroy: () => {
        iframe.remove();
        return Promise.resolve();
      },
    };
  }

  const vimeo = new Vimeo.Player(node, {
    dnt: true,
    id: videoId,
    width: 1080,
  });

  return vimeo;
}

function destroyPlayer(player) {
  if (!player || typeof player.destroy !== "function") {
    return Promise.resolve();
  }
  return player.destroy();
}

function initLightbox() {
  const containers = document.querySelectorAll(".wp-block-blueprint-video");
  if (!containers) return;

  for (const container of containers) {
    const playButton = container.querySelector(".video-play-button > button");
    if (!playButton) continue;

    const lightbox = container.querySelector(".lightbox");
    if (!lightbox) continue;

    const player = lightbox.querySelector(".inline-video-player");
    if (!player) continue;

    const closeButton = player.querySelector(".close-lightbox");
    if (!closeButton) continue;

    let mediaPlayer = undefined;

    playButton.addEventListener("click", function () {
      if (!lightbox.classList.contains("active")) {
        lightbox.classList.add("active");

        mediaPlayer = buildInlineVideoPlayer(player);

        if (!mediaPlayer) return;

        mediaPlayer.ready().then(function () {
          player.classList.add("ready");
          if (typeof mediaPlayer.play === "function") {
            mediaPlayer.play();
          }
        });
      }
    });

    closeButton.addEventListener("click", function () {
      if (lightbox.classList.contains("active")) {
        destroyPlayer(mediaPlayer).then(function () {
          lightbox.classList.remove("active");
          player.classList.remove("ready");
          mediaPlayer = undefined;
        });
      }
    });

    lightbox.addEventListener("click", function (e) {
      if (e.target === lightbox && lightbox.classList.contains("active")) {
        destroyPlayer(mediaPlayer).then(function () {
          lightbox.classList.remove("active");
          player.classList.remove("ready");
          mediaPlayer = undefined;
        });
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  initLightbox();
});
